export default __webpack_public_path__ + "slices/main/assets/public/media/product/platform/platform-feature-company@2x.fc4f03890fc252aca07647d0084cd27e.png";